import {SingleScoData} from "scorm/scorm_1_2/SingleScoData";
import {Assert} from "common/Assert";

export function initializeScormData( lmsResponse, masteryScore = 80 ) {

    Assert.checkArgument( lmsResponse );
    Assert.checkArgumentType( masteryScore, "number" );

    const scormScoData = new SingleScoData();

    scormScoData.set( "cmi.core.student_name", lmsResponse.get("Student_Name") || "");
    scormScoData.set( "cmi.core.student_id", lmsResponse.get("Student_ID") || "" );
    scormScoData.set( "cmi.core.lesson_status", lmsResponse.get("Lesson_Status") || "n");

    const asStatus = scormScoData.get("cmi.core.lesson_status").split(",");
    if (asStatus.length > 0) {
        scormScoData.set("cmi.core.lesson_status", asStatus[0]);
    }
    if (asStatus.length > 1) {
        scormScoData.set("cmi.core.entry", asStatus[1]);
    }

    scormScoData.set("cmi.core.credit", lmsResponse.get("Credit") || "credit");
    scormScoData.set("cmi.core.score.raw", lmsResponse.get("Score") || "0");
    scormScoData.set("cmi.suspend_data", decodeURIComponent( lmsResponse.get("ttkf_data") ) || "null");
    scormScoData.set("cmi.student_data.mastery_score", lmsResponse.get("Mastery_Score") || masteryScore.toString() );

    scormScoData.set("cmi.student_data.max_time_allowed", "" );
    scormScoData.set("cmi.student_data.time_limit_action", "" );

    return scormScoData;
}
